/**
 * Work Orders list view — the Reactive | Preventive | All toggle on the list and the
 * organization-level default an admin sets under Settings → Organization.
 *
 * Resolution order on the list: `?workType=` URL param → org default
 * (`authUser.activeOrganizationDefaultWorkOrderView`) → REACTIVE.
 */
export const WORK_ORDER_VIEWS = ['REACTIVE', 'PREVENTIVE', 'ALL'];

/** Uppercases and validates a view value; null when it isn't one of WORK_ORDER_VIEWS. */
export const normalizeWorkOrderView = (value) => {
  const v = String(value || '').toUpperCase();
  return WORK_ORDER_VIEWS.includes(v) ? v : null;
};

/** Localized options for the list toggle and the org-settings select (same order everywhere). */
export const workOrderViewOptions = (t) => [
  { value: 'REACTIVE', label: t('shared.reactive', 'Reactive') },
  { value: 'PREVENTIVE', label: t('shared.preventive', 'Preventive') },
  { value: 'ALL', label: t('shared.all', 'All') },
];
